module.exports = __webpack_public_path__ + "img/globe-snow.88a5d324.svg";